<section class="general-container">
  <div class="general-data">
    <div class="title">Version:</div>
    <div class="value">{{ version }}</div>
    <div class="title">Host:</div>
    <div class="value">{{ license?.address }}</div>
    <div class="title">Status:</div>
    <div class="value">
      <p-select
        [(ngModel)]="selectedStatus"
        (onChange)="onStatusChange($event.value)"
        [options]="licenseService.statusOptions$"
        optionLabel="name"
        [disabled]="isUpdatingStatus || !license?.id"
        fluid
        [ngModelOptions]="{ standalone: true }"
      ></p-select>
    </div>
  </div>
</section>
